import { store } from "../store/index";
import {
  filterVariety,
  removeVariety,
  modifyVariety,
  getVarietyByUuid,
  createVariety,
  getAll,
} from "../store/actions/VarietyActions";

/**
 * Create Variety
 */
export const addVariety = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createVariety(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Variety
 */
export const getVariety = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getVarietyByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Variety
 */
export const updateVariety = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(modifyVariety(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Variety
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterVariety(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Variety
 */
export const deleteVariety = async (uuid) => {
  const result = await store.dispatch(removeVariety([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Get all varieties
 */
export const getAllVarieties = async (filters = {}) => {
  const result = await store.dispatch(getAll(filters));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
